'use strict';

import { isBrowser } from '../environment';
import svtDataSdkClient from '../../../client/dataLake';
import { listTrackingEvent } from './customEvents';

const waitForAbiskoSetup = isBrowser()
    ? require('../../../client/abisko').waitForAbiskoSetup
    : Promise.resolve();

function setOrvestoData(orvestoData) {
    const orvestoLib = isBrowser() && window._cInfo;
    if (orvestoLib && document.cookie.match('__codnt') === null) {
        orvestoLib.push({ cmd: '_trackContentPath', val: orvestoData }, { cmd: '_executeTracking' });
    }
}

export function sendOrvestoStatistics(orvestoData) {
    if (orvestoData) {
        setOrvestoData(orvestoData);
    }
}

const DEFAULT_DATA_LAKE = {
    content: {
        id: undefined,
        type: undefined,
    },
};

export function trackViewEvent(data = {}) {
    waitForAbiskoSetup.then(() => {
        svtDataSdkClient.trackViewEvent({ ...DEFAULT_DATA_LAKE, ...data });
    });
}

// https://git.svt.se/data/web-sdk#custom-event
export function trackCustomEvent(data = {}) {
    waitForAbiskoSetup.then(() => {
        svtDataSdkClient.trackCustomEvent({ ...data });
    });
}

// https://git.svt.se/data/web-sdk#custom-event
export function trackNonInteractiveEvent(data = {}) {
    waitForAbiskoSetup.then(() => {
        svtDataSdkClient.trackNonInteractiveEvent({ ...data });
    });
}

export const createListTrackingOnClick =
    (listTracking) =>
    (e, itemPosition, svtId, leadsToPlayable = false, linkFromImage = false) => {
        const eventData = {
            ...listTracking,
            listItemIndex: itemPosition,
            contentId: svtId,
            leadsToPlayable,
            linkFromImage,
        };

        trackCustomEvent(listTrackingEvent(eventData, e.currentTarget));
    };
